module.exports = __webpack_public_path__ + "img/LA-cleantech-incubator@3x.d30d414c.webp";